import { createListFilters } from '../../../../../components'

export type ExamesClienteFilters = {
  /** Nome do exame (busca parcial). */
  exame: string
}

export const { ListFiltersProvider, useListFilters } = createListFilters<ExamesClienteFilters>({
  exame: '',
})
